import { render, staticRenderFns } from "./PowerpointOnlineNotSupport.vue?vue&type=template&id=4cfa6e8f"
import script from "./PowerpointOnlineNotSupport.vue?vue&type=script&lang=js"
export * from "./PowerpointOnlineNotSupport.vue?vue&type=script&lang=js"
import style0 from "./PowerpointOnlineNotSupport.vue?vue&type=style&index=0&id=4cfa6e8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports